exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".authority .el-input-number {\n  margin-left: 15px;\n}\n.authority .el-input-number span {\n  display: none;\n}\n.authority .button-box {\n  padding: 10px 20px;\n}\n.authority .button-box .el-button {\n  float: right;\n}\n.role-box .el-tabs__content {\n  height: calc(100vh - 150px);\n  overflow: auto;\n}", ""]);

// exports
